<template>
  <ul class="navigation-grid container">
    <li v-for="item in menuItems" :key="item.name">
      <NuxtLink :to="item.link" class="navigation-grid__link">
        <NuxtTransformImage
          :src="`/assets/artnight/homepage/navigation-grid/${item.name}.png`"
          :alt="item.name"
          fit="cover"
          sizes="sm:165px md:183px lg:165px"
        />
        <p class="navigation-grid__title">{{ $t(`homepage.navigation_grid.${item.name}`) }}</p>
      </NuxtLink>
    </li>
  </ul>
</template>

<script setup lang="ts">
import {
  ONLINE_PRODUCTS_PATH,
  KIDS_PRODUCTS_PATH,
  VOUCHER_PRODUCTS_PATH,
  GROUP_PRODUCTS_PATH,
  THEMES_PATH
} from '@/resources/helpers';

const NuxtTransformImage = defineAsyncComponent(() => import('@/components/molecules/NuxtTransformImage.vue'));

const runtimeConfig = useRuntimeConfig();

const menuItems = [
  { name: 'acryl', link: `${THEMES_PATH}${runtimeConfig.public.acryl_category}` },
  { name: 'aquarell', link: `${THEMES_PATH}${runtimeConfig.public.aquarell_category}` },
  { name: 'voucher', link: VOUCHER_PRODUCTS_PATH },
  { name: 'kids', link: KIDS_PRODUCTS_PATH },
  { name: 'online', link: ONLINE_PRODUCTS_PATH },
  { name: 'group', link: GROUP_PRODUCTS_PATH }
];
</script>

<style lang="scss" scoped>
@use '@/assets/styles/css_BASE/helpers/mixins/font-size.scss' as *;
@use '@/assets/styles/css_BASE/helpers/mixins/_bp.scss' as *;

.navigation-grid {
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 25px;
  margin: 40px 20px;
  justify-items: center;
  @include bp(sm) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    margin: 40px 20px;
  }

  @include bp(md) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
    margin: 40px 20px;
  }

  @include bp(lg) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
    margin: 40px auto;
  }

  li {
    list-style-type: none;
    padding-left: 0;
    width: 100%;

    &:deep(img) {
      width: 100%;
    }
  }

  &__link {
    display: block;

    &:deep(img) {
      width: 100%;
    }
  }

  &__title {
    @include font-size(17px);
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    margin-bottom: 20px;

    @include bp(lg) {
      @include font-size(24px);
      line-height: 130%;
    }
  }
}

@media (min-width: 768px) {
  .navigation-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

@media (min-width: 912px) {
  .navigation-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

@media (min-width: 992px) {
  .navigation-grid {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
</style>
